// Libraries
var React = require('react');

// Components
var CallToAction = require('CallToAction/CallToAction');
var RestrictedComponent = require('RestrictedComponent/RestrictedComponent');

// Styles
require('./PromoBannerModule.scss');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

class PromoBannerModule extends React.Component {
	// componentDidMount() {
		// const picturefill = require('picturefill');
		// picturefill();
	// }

	createDescription = () => {
        return {__html: this.props.data.description};
	};

	render() {
		const img = (
			<div className="PromoBanner__image" data-bg={this.props.data.image.smallUrl + '*,*' + this.props.data.image.mediumUrl + '*,*' + this.props.data.image.largeUrl + '*,*' + this.props.data.image.extraLargeUrl}>
				<img src={PlaceholderImg} data-src={this.props.data.image.smallUrl + '*,*' + this.props.data.image.mediumUrl + '*,*' + this.props.data.image.largeUrl + '*,*' + this.props.data.image.extraLargeUrl} alt="" />
			</div>
		);

		const background = this.props.data.background && this.props.data.background !== 'default'
			? this.props.data.background
			: '';

		const title = <h3 className="PromoBanner__title">{this.props.data.title}</h3>

		return (
			<div className="PromoBanner" id={this.props.data.id}>
				<div className={"PromoBanner__container " + this.props.data.position || ""}>
					{this.props.data.link ? (
						<a href={this.props.data.link.url}>{img}</a>
					) : img}
					<div className={"PromoBanner__content " + background}>
						<RestrictedComponent hasAccess={!this.props.data.link || (this.props.data.link && this.props.data.link.hasAccess)} isVideo={false}>
							<div className="PromoBanner__tags">
								{this.props.data.tags !== null && this.props.data.tags.map((item) => {
									return (
										<a className="PromoBanner__tag" href={item.url} key={item.id} rel="nofollow">{item.hashtag}</a>
									);
								})}
							</div>
							{this.props.data.link ? (
								<a href={this.props.data.link.url}>{title}</a>
							) : title}
							<p className="PromoBanner__description" dangerouslySetInnerHTML={this.createDescription()}></p>
							{this.props.data.link && <CallToAction {...this.props.data.link}/>}
						</RestrictedComponent>
					</div>
				</div>
			</div>
		)
	}
}

module.exports = PromoBannerModule;



// WEBPACK FOOTER //
// ./src/components/PromoBanner/PromoBannerModule.js